module.exports = __webpack_public_path__ + "static/img/sanwei-img.4ce45274.png";